<template>
  <div class="adminOptions" v-click-outside="closeOptions">
    <transition name="fade">
      <div class="optionsOpen" v-if="open">
        <div class="optionsAdd">
          Add to Scrapbook:
          <ul v-if="scrapbooks">
            <li v-for="scrapbook in scrapbooks" :key="scrapbook.id">
              <span v-if="itemScrapbooks && itemScrapbooks.indexOf(scrapbook.id) > -1" class="inScrapbook">
                {{ scrapbook.name }} <Check /> <button class="nobutton" @click="deleteItemFromScrapbook(scrapbook)"><Trash /></button>
              </span>
              <span v-else><a :href="scrapbook.id" @click.prevent="addItemToScrapbook(scrapbook)">{{ scrapbook.name }}</a></span>
            </li>
          </ul>
          <AddScrapbook :item="item" />
        </div>
      </div>
    </transition>
    <button class="nobutton plus" @click.prevent="toggleOptions">+</button>
  </div>

</template>

<script>
import store from '@/store'
import Check from "@/components/layout/Check.vue";
import Trash from "@/components/layout/Trash.vue";
import AddScrapbook from "@/components/scrapbooks/AddScrapbook.vue";
import DataScrapbooks from "@/js/data/controllers/DataScrapbooks.js";


export default {
  name: 'scrapbooks-admin-option',
  components: {
    AddScrapbook,
    Check,
    Trash
  },
  data () {
    return {
      open: false
    }
  },
  props: ['item'],
  computed: {
    scrapbooks () {
      return store.state.user.scrapbooks
    },
    itemScrapbooks () {
      let id = this.$props.item.id
      if (store.state.scrapbooks.byItem[id]) {
        return store.state.scrapbooks.byItem[id].scrapbooks
      }
      return []
    }
  },
  mounted () {
    document.addEventListener('click', this.outsideClickListener)
  },
  methods: {
    openOptions () {
      this.open = true
    },
    closeOptions (e) {
      const classes = e.target.classList
      if (this.open && !classes.contains('addScrapbookButton')) {
        this.open = false
      }


    },
    toggleOptions () {
      this.open = !this.open
    },
    addItemToScrapbook (scrapbook) {
      let params = {
        scrapbook_id: scrapbook.id,
        item_id: this.item.id
      }
      DataScrapbooks.addItemToScrapbook(params);
    },
    deleteItemFromScrapbook (scrapbook) {
      let c = confirm('Are you sure you want to remove this item from the scrapbook')
      if (c) {
        let params = {
          scrapbook_id: scrapbook.id,
          item_id: this.item.id
        }
        DataScrapbooks.deleteItemFromScrapbook(params);
      }
    }

  }
}
</script>

<style scoped lang="scss">
  .adminOptions {
    position: relative;
  }
  .optionsOpen {
    position: absolute;
    background-color: $brandGrey;
    padding: 10px 20px;
    bottom: 50px;
    left: -110px;
    width: 200px;
  }
  .lightbox .nobutton.plus {
    font-size: 36px;
    color: $brandLightGreen;
    margin: 20px 0 25px;
  }
  ul {
    list-style: none;
    padding-left: 0;
  }
  a {
    color: $brandGreen;
    &:hover {
      color: $brandLightGreen;
    }
  }

  .inScrapbook {
    color: $brandLightGreen;
  }

  .lightbox .nobutton {
    color: $brandGreen;
    font-size: 12px;
  }
</style>
